import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const CPMDumpExportRequest = (Values, UserId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RanReportKpis/GenerateCPMExport`,
	data: { Values, UserId }
});
